import { createContext } from 'react';

import type { RtcConnection } from 'features/sip/interfaces';

export const SipConnectionContext = createContext<RtcConnection | null>(null);
